import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useEffect } from 'react';
import toast, { useToaster, Toaster as Toaster$1 } from 'react-hot-toast';

var Toaster = function (_a) {
    var children = _a.children;
    var toastLimit = 3;
    var toasts = useToaster().toasts;
    // dismiss old toasts if toast limit is reached
    useEffect(function () {
        toasts
            .filter(function (t) { return t.visible; })
            .filter(function (_, i) { return i >= toastLimit; })
            .forEach(function (t) { return toast.dismiss(t.id); });
    }, [toasts]);
    return (jsx(Toaster$1, __assign({ position: "bottom-left", gutter: 8 }, { children: children })));
};
Toaster.displayName = "Toaster";

export { Toaster };
//# sourceMappingURL=Toaster.js.map
